import { render, staticRenderFns } from "./ProductDetailDialog.vue?vue&type=template&id=86dd1c90&scoped=true"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailDialog.vue?vue&type=style&index=0&id=86dd1c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dd1c90",
  null
  
)

export default component.exports